
import React from 'react';
import { format } from 'date-fns';
import { MessageCircle, User, AlertCircle, WifiOff } from 'lucide-react';
import { SupportMessage as SupportMessageType } from '@/integrations/supabase/client';

interface SupportMessageProps {
  message: SupportMessageType;
}

export const SupportMessage: React.FC<SupportMessageProps> = ({ message }) => {
  const isUser = message.sender_type === 'user';
  
  // Check for different error types
  const isError = message.content.startsWith('Error:') || 
                 message.content.startsWith('Na vjen keq') ||
                 message.content.includes('gabim');
                 
  const isNetworkError = isError && (
    message.content.includes('Network') || 
    message.content.includes('connection') || 
    message.content.includes('lidhje') ||
    message.content.includes('retry')
  );
  
  const isServerError = isError && (
    message.content.includes('Server') || 
    message.content.includes('service') || 
    message.content.includes('shërbim')
  );
  
  const formattedTime = format(new Date(message.created_at), 'HH:mm');
  
  return (
    <div className={`flex items-start gap-3 ${isUser ? 'flex-row-reverse' : ''}`}>
      <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
        isUser ? 'bg-brand-100' : 
        isNetworkError ? 'bg-orange-100' :
        isServerError ? 'bg-red-100' :
        isError ? 'bg-red-100' : 
        'bg-gray-200'
      }`}>
        {isUser ? (
          <User size={16} />
        ) : isNetworkError ? (
          <WifiOff size={16} className="text-orange-500" />
        ) : isError ? (
          <AlertCircle size={16} className="text-red-500" />
        ) : (
          <MessageCircle size={16} />
        )}
      </div>
      
      <div className={`rounded-lg px-4 py-2 max-w-[75%] ${
        isUser 
          ? 'bg-brand-100 text-brand-900' 
          : isNetworkError
            ? 'bg-orange-50 text-orange-800 border border-orange-200'
            : isError
              ? 'bg-red-50 text-red-800 border border-red-200'
              : 'bg-gray-100 text-gray-800'
      }`}>
        <div className="text-sm whitespace-pre-wrap">{message.content}</div>
        <div className={`text-xs mt-1 ${
          isUser 
            ? 'text-brand-500' 
            : isNetworkError
              ? 'text-orange-500'
              : isError
                ? 'text-red-500'
                : 'text-gray-500'
        }`}>
          {formattedTime}
        </div>
      </div>
    </div>
  );
};
